class StarboyShippingProgress extends HTMLElement {
  connectedCallback() {
    const currency = this.dataset.currency;
    const baseCurrency = this.dataset.baseCurrency;
    const conversion = window.Shopify?.currency;

    const rate =
      currency === baseCurrency
        ? 1
        : conversion?.active === currency
          ? Number(conversion.rate)
          : NaN;

    const total = Number(this.dataset.total);
    const goal = Number(this.dataset.goal) * rate;

    // No mostrar una promesa de envío gratis si falta la conversión.
    if (
      !Number.isFinite(rate) ||
      rate <= 0 ||
      !Number.isFinite(total) ||
      !Number.isFinite(goal) ||
      goal <= 0
    ) {
      this.hidden = true;
      return;
    }

    const remaining = Math.max(0, Math.ceil(goal - total));
    const progress = Math.min(100, Math.max(0, (total / goal) * 100));

    const amount = new Intl.NumberFormat(
      document.documentElement.lang || 'en',
      {
        style: 'currency',
        currency,
      }
    ).format(remaining / 100);

    this.querySelector('[data-shipping-message]').textContent =
      remaining === 0
        ? "Congratulations! You've got free shipping!"
        : `You're only ${amount} away from free shipping!`;

    const track = this.querySelector('[role="progressbar"]');
    track.setAttribute('aria-valuenow', String(Math.round(progress)));
    const fill = this.querySelector('[data-shipping-fill]');
    const drawer = this.closest('cart-drawer');
    const previous = drawer?._starboyShippingProgress;

    const startProgress =
      previous?.currency === currency
        ? previous.progress
        : 0;

    // Recupera el relleno anterior aunque se reconstruya el carrito.
    fill.style.transition = 'none';
    fill.style.width = `${startProgress}%`;

    if (drawer) {
      drawer._starboyShippingProgress = {
        currency,
        progress,
      };
    }

    // Muestra el estado inicial antes de animar al nuevo valor.
    requestAnimationFrame(() => {
      if (!this.isConnected) return;

      void fill.offsetWidth;

      requestAnimationFrame(() => {
        if (!this.isConnected) return;

        fill.style.removeProperty('transition');
        fill.style.width = `${progress}%`;
      });
    });


    const summary = this.closest('cart-drawer')
      ?.querySelector('[data-starboy-shipping-summary]');

    if (summary) {
      summary.textContent =
        remaining === 0
          ? 'Free Shipping'
          : 'Calculate On Checkout Page';
    }

    this.hidden = false;
    this.classList.remove('is-complete');

    if (remaining === 0) {
      setTimeout(() => {
        if (this.isConnected) {
          this.classList.add('is-complete');
        }
      }, 450);
    }




  }
}

if (!customElements.get('starboy-shipping-progress')) {
  customElements.define(
    'starboy-shipping-progress',
    StarboyShippingProgress
  );
}
